import { render, staticRenderFns } from "./SubscriptionWhats.vue?vue&type=template&id=45531637&scoped=true&"
import script from "./SubscriptionWhats.vue?vue&type=script&lang=js&"
export * from "./SubscriptionWhats.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionWhats.vue?vue&type=style&index=0&id=45531637&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45531637",
  null
  
)

export default component.exports